import AnalyticsHelper from '../../utils/analytics-helper.js';
import Animate from '../helpers/animate.js';

export default class Footer {
    constructor(el) {
        this.el = el;
        this.body = document.querySelector('body');
        this.accordionButton = el.querySelector('.footerAccordionButton');
        this.backToTop = el.querySelector('.buttonWrap > a');
        this.languageSelector = el.querySelector('.languageSelector');
        this.social = el.querySelector('.social');
        this.bind();
        this.count();
    }

    bind() {
        this.accordionButton?.addEventListener('click', (e) => this.toggle(e));
        this.backToTop?.addEventListener('click', (e) => this.scrollToTop(e));
        this.languageSelector?.addEventListener('click', (e) => this.selectLanguage(e));
    }

    toggle(e) {
        e.preventDefault();
        const isExpanded = this.accordionButton.getAttribute('aria-expanded') === 'true';
        this.accordionButton.setAttribute('aria-expanded', !isExpanded);
    }

    scrollToTop(e) {
        e.preventDefault();
        Animate.scroll(this.body);
        AnalyticsHelper.push(this.backToTop);
    }
    selectLanguage(e) {
        this.languageSelector.classList.toggle('active');
    }

    count() {
        this.social.dataset.amount = this.social.querySelectorAll('li').length;
    }
}
if (document.querySelector('.responsiveFooter')) {
    const footer = new Footer(document.querySelector('.responsiveFooter'));
}
